/* ============================================================
   LCS — Shell behavior
   - Cursor toggle (neon ↔ classic) persistido en localStorage
   - HorizontalHeader: estático (sin panel). No requiere JS.
   - MobileMenu: trigger desde .mobile-header__menu (hamburger), full-screen overlay
   - CartDrawer: abrir/cerrar con .cart-scrim y botones data-cart-open
   ============================================================ */
(function () {
  'use strict';

  // ===== Cursor toggle =====
  // DESACTIVADO 2026-04-27 por decisión de Marcelo. Reactivar descomentando
  // este bloque + el bloque "Cursor neon" en lcs-base.css + agregando
  // de vuelta el .cursor-switch en lcs-horizontal-header.liquid.
  /*
  const CURSOR_KEY = 'lcs-cursor-mode';
  const initialCursor = localStorage.getItem(CURSOR_KEY) || 'neon';
  document.body.dataset.cursor = initialCursor;

  function setCursor(mode) {
    localStorage.setItem(CURSOR_KEY, mode);
    document.body.dataset.cursor = mode;
    document.querySelectorAll('.cursor-switch').forEach(sw => {
      const isOn = mode === 'neon';
      sw.dataset.on = isOn ? 'true' : 'false';
      sw.classList.toggle('is-on', isOn);
      sw.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });
    document.querySelectorAll('[data-cursor-label]').forEach(label => {
      const target = label.dataset.cursorLabel;
      label.classList.toggle('is-active', target === mode);
    });
  }

  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.cursor-switch');
    if (!sw) return;
    const cur = document.body.dataset.cursor || 'neon';
    setCursor(cur === 'neon' ? 'classic' : 'neon');
  });

  document.addEventListener('DOMContentLoaded', () => setCursor(initialCursor));
  */
  function setCursor() { /* noop while disabled */ }

  // ===== HorizontalHeader =====
  // El header desktop ahora es estático (sin panel desplegable). No requiere JS.
  // El handler de Escape se mantiene para cerrar mobile menu y cart drawer.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeMobileMenu();
      closeCart();
    }
  });

  // ===== MobileMenu: overlay debajo del mobile-header =====
  // El mismo botón hamburger (data-mobile-menu-toggle) abre y cierra. No hay ✕.
  // Toggle de la clase .mobile-menu--open → CSS hace la animación bidireccional.
  const mobileMenu = document.querySelector('.mobile-menu');
  const mmTrigger  = document.querySelector('[data-mobile-menu-toggle]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('mobile-menu--open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('mobile-menu--open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (mmTrigger) mmTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    if (mobileMenu.classList.contains('mobile-menu--open')) closeMobileMenu();
    else openMobileMenu();
  });

  // Cierra el mobile menu al click en un item
  document.querySelectorAll('.mm-item').forEach(it => {
    it.addEventListener('click', closeMobileMenu);
  });

  // ===== CartDrawer =====
  function getDrawer() { return document.querySelector('.cart-drawer'); }
  function getScrim()  { return document.querySelector('.cart-scrim'); }

  function openCart() {
    const drawer = getDrawer();
    const scrim  = getScrim();
    if (!drawer || !scrim) return;
    drawer.dataset.open = 'true';
    scrim.dataset.open = 'true';
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    const drawer = getDrawer();
    const scrim  = getScrim();
    if (!drawer || !scrim) return;
    drawer.dataset.open = 'false';
    scrim.dataset.open = 'false';
    document.body.style.overflow = '';
  }

  // ===== Sidebar Predictive Search =====
  // Live dropdown con thumbnails + nombre + precio.
  // - Tipear (debounce 200ms) → fetch a /search/suggest.json → render dropdown.
  // - Click en resultado → navega al PDP.
  // - Enter → navega al primer resultado (atajo).
  // - ESC o click fuera → cierra el dropdown.
  (function setupSidebarSearch () {
    const form = document.querySelector('[data-search-direct]');
    if (!form) return;
    const input = form.querySelector('[data-search-input]');
    const box   = form.querySelector('[data-search-results]');
    if (!input || !box) return;

    let debounceId = null;
    let lastProducts = [];

    function esc (s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function closeBox () {
      box.dataset.open = 'false';
      box.innerHTML = '';
      lastProducts = [];
    }
    function openBox () { box.dataset.open = 'true'; }

    function render (products, query) {
      if (!products.length) {
        box.innerHTML = '<div class="lcs-sidebar__search-empty">no hay resultados para "' + esc(query) + '"</div>';
        openBox();
        return;
      }
      box.innerHTML = products.map(p => {
        const img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : '';
        const price = p.price != null ? esc(p.price) : '';
        const title = esc(p.title || '');
        const url   = p.url || '#';
        return ''
          + '<a href="' + esc(url) + '" class="lcs-sidebar__search-result">'
          + (img ? '<img src="' + esc(img) + '" alt="" class="lcs-sidebar__search-result-img" loading="lazy">' : '<div class="lcs-sidebar__search-result-img"></div>')
          +   '<div class="lcs-sidebar__search-result-info">'
          +     '<span class="lcs-sidebar__search-result-name">' + title + '</span>'
          +     (price ? '<span class="lcs-sidebar__search-result-price">' + price + '</span>' : '')
          +   '</div>'
          + '</a>';
      }).join('');
      openBox();
    }

    async function fetchResults (query) {
      if (!query || query.length < 2) { closeBox(); return; }
      try {
        const url = '/search/suggest.json?q=' + encodeURIComponent(query)
                  + '&resources[type]=product&resources[limit]=6'
                  + '&resources[options][unavailable_products]=last';
        const res = await fetch(url);
        if (!res.ok) throw new Error('search api fail');
        const data = await res.json();
        const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        lastProducts = products;
        render(products, query);
      } catch (err) {
        console.error('LCSShell: predictive search error', err);
        closeBox();
      }
    }

    input.addEventListener('input', () => {
      clearTimeout(debounceId);
      const q = input.value.trim();
      debounceId = setTimeout(() => fetchResults(q), 200);
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        input.blur();
        closeBox();
      }
    });

    document.addEventListener('mousedown', (e) => {
      if (!form.contains(e.target)) closeBox();
    });

    // Submit (Enter): si tenemos resultados → primer producto; si no, fetch + redirect.
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const q = (input.value || '').trim();
      if (!q) return;
      const fallbackUrl = form.action + '?q=' + encodeURIComponent(q);
      if (lastProducts.length && lastProducts[0].url) {
        window.location.href = lastProducts[0].url;
        return;
      }
      try {
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=1';
        const res = await fetch(url);
        if (!res.ok) throw new Error('search api fail');
        const data = await res.json();
        const first = data && data.resources && data.resources.results && data.resources.results.products && data.resources.results.products[0];
        window.location.href = (first && first.url) ? first.url : fallbackUrl;
      } catch (err) {
        window.location.href = fallbackUrl;
      }
    });
  })();

  // Re-renderizar el HTML del cart drawer y cart floater desde el servidor.
  // Usa Shopify Section Rendering API: GET /?sections=lcs-cart-drawer.
  // Se llama después de cualquier cambio en el cart (add, remove, update qty).
  async function refreshCartUI() {
    try {
      const res = await fetch('/?sections=lcs-cart-drawer');
      if (!res.ok) return;
      const data = await res.json();
      const html = data['lcs-cart-drawer'];
      if (!html) return;

      // El section viene wrappeado en su shopify-section div. Parseamos para extraer.
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newDrawer = tmp.querySelector('.cart-drawer');
      const newScrim  = tmp.querySelector('.cart-scrim');
      const oldDrawer = getDrawer();
      const oldScrim  = getScrim();

      if (newDrawer && oldDrawer) {
        const wasOpen = oldDrawer.dataset.open === 'true';
        oldDrawer.outerHTML = newDrawer.outerHTML;
        if (wasOpen) {
          // Re-aplicar estado abierto al nuevo nodo
          getDrawer().dataset.open = 'true';
        }
      }
      if (newScrim && oldScrim) {
        const wasOpen = oldScrim.dataset.open === 'true';
        oldScrim.outerHTML = newScrim.outerHTML;
        if (wasOpen) getScrim().dataset.open = 'true';
      }
    } catch (err) {
      console.error('LCSShell: error refrescando cart drawer', err);
    }
  }

  // Update cart count: badge separado encima del icon SVG. Solo aparece si > 0.
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const count = cart.item_count;
      // Floater desktop
      const floater = document.querySelector('.cart-floater');
      if (floater) {
        let badge = floater.querySelector('[data-cart-count-badge]');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'cart-floater__badge';
            badge.dataset.cartCountBadge = '';
            floater.appendChild(badge);
          }
          badge.textContent = count;
        } else if (badge) {
          badge.remove();
        }
      }
      // Mobile header cart
      const mobileCart = document.querySelector('.mobile-header__cart');
      if (mobileCart) {
        let badge = mobileCart.querySelector('[data-cart-count-badge]');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'mobile-header__cart-badge';
            badge.dataset.cartCountBadge = '';
            mobileCart.appendChild(badge);
          }
          badge.textContent = count;
        } else if (badge) {
          badge.remove();
        }
      }
      // Sidebar cart link: contador inline siempre visible (incluye 0)
      document.querySelectorAll('[data-cart-count-inline]').forEach(el => {
        el.textContent = count;
      });
    } catch (err) {
      console.error('LCSShell: error actualizando count', err);
    }
  }

  // Cambiar cantidad de un line item vía AJAX (sin recargar la página).
  // quantity: 0 elimina el item del carro; cualquier otro entero >=1 lo ajusta.
  async function changeCartLine(line, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) }),
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      await Promise.all([refreshCartUI(), refreshCartCount()]);
    } catch (err) {
      console.error('LCSShell: error cambiando cantidad', err);
    }
  }
  // Helpers semánticos sobre changeCartLine
  function removeCartLine(line) { return changeCartLine(line, 0); }
  function getCurrentQty(line) {
    const row = document.querySelector('.cart-row[data-cart-line="' + line + '"]');
    if (!row) return null;
    const valEl = row.querySelector('[data-cart-qty-value]');
    if (!valEl) return null;
    return parseInt(valEl.textContent, 10) || 0;
  }
  function incrementCartLine(line) {
    const cur = getCurrentQty(line);
    if (cur === null) return;
    return changeCartLine(line, cur + 1);
  }
  function decrementCartLine(line) {
    const cur = getCurrentQty(line);
    if (cur === null) return;
    // Si llega a 0, Shopify lo elimina automáticamente (el line item desaparece
    // y los siguientes line items se renumeran — refreshCartUI re-renderea todo).
    return changeCartLine(line, Math.max(0, cur - 1));
  }

  document.addEventListener('click', (e) => {
    // Abrir cart
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openCart();
      return;
    }
    // Cerrar cart
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeCart();
      return;
    }
    // Quitar item del cart (elimina todo el line item)
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      const line = removeBtn.dataset.cartRemove;
      removeCartLine(line);
      return;
    }
    // Stepper: restar uno a la cantidad de un line item
    const decBtn = e.target.closest('[data-cart-decrement]');
    if (decBtn) {
      e.preventDefault();
      decrementCartLine(decBtn.dataset.cartDecrement);
      return;
    }
    // Stepper: sumar uno a la cantidad de un line item
    const incBtn = e.target.closest('[data-cart-increment]');
    if (incBtn) {
      e.preventDefault();
      incrementCartLine(incBtn.dataset.cartIncrement);
      return;
    }
  });
  // Click en scrim cierra (el scrim se re-renderea, así que delegamos)
  document.addEventListener('click', (e) => {
    if (e.target.classList && e.target.classList.contains('cart-scrim')) {
      closeCart();
    }
  });

  // ===== Fade-in de imágenes (grid + PDP) =====
  // Las imágenes empiezan con opacity: 0 (CSS) y reciben .is-loaded cuando termina
  // de cargar el archivo. Resultado: fade-in suave en lugar de "pop in" abrupto.
  function markLoadedImages() {
    document.querySelectorAll('.product-card__img, .pdp__media-item img').forEach(img => {
      if (img.classList.contains('is-loaded')) return;
      if (img.complete && img.naturalHeight !== 0) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load',  () => img.classList.add('is-loaded'), { once: true });
        img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true });
      }
    });
  }
  markLoadedImages();
  // Re-run cuando aparecen nuevas imágenes en el DOM (lazy loading, async sections, etc.)
  new MutationObserver(markLoadedImages).observe(document.body, { childList: true, subtree: true });

  // ===== Scroll restore al volver del PDP =====
  // DESACTIVADO 2026-04-28 por decisión de Marcelo. Con catálogo de 10
  // productos cabe casi todo en 2 pantallas y la mejora era imperceptible.
  // Reactivar descomentando cuando crezca el catálogo (AW2027, drops futuros).
  /*
  function isCollectionLike() {
    return /\/collections\//.test(window.location.pathname) ||
           window.location.pathname === '/' ||
           window.location.pathname === '';
  }
  window.addEventListener('pagehide', () => {
    if (!isCollectionLike()) return;
    const key = 'lcs-scroll-' + window.location.pathname;
    try { sessionStorage.setItem(key, String(window.scrollY)); } catch (err) {}
  });
  window.addEventListener('pageshow', () => {
    if (!isCollectionLike()) return;
    const key = 'lcs-scroll-' + window.location.pathname;
    let saved = null;
    try { saved = sessionStorage.getItem(key); } catch (err) {}
    if (saved !== null) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(saved, 10) || 0);
        try { sessionStorage.removeItem(key); } catch (err) {}
      }, 50);
    }
  });
  */

  /* ============================================================
     INFINITE SCROLL — Collection grid
     ------------------------------------------------------------
     El template de colección (lcs-collection.liquid) renderiza un
     sentinel <div data-infinite-sentinel data-next-url="..."> al
     final del grid si hay próxima página. Aquí lo observamos con
     IntersectionObserver: cuando entra al viewport, fetcheamos el
     URL siguiente, parseamos la respuesta y appendeamos los nuevos
     product cards al grid existente. El sentinel se actualiza con
     el siguiente next-url o se elimina si ya no hay más.
     Anti-doble-fetch: flag `loading` mientras hay request en vuelo.
     ============================================================ */
  (function initInfiniteScroll() {
    const grid = document.querySelector('[data-products-grid]');
    const sentinel = document.querySelector('[data-infinite-sentinel]');
    const loader = document.querySelector('[data-infinite-loader]');
    if (!grid || !sentinel || !('IntersectionObserver' in window)) return;

    let loading = false;
    let nextUrl = sentinel.getAttribute('data-next-url');

    async function loadMore() {
      if (loading || !nextUrl) return;
      loading = true;
      if (loader) loader.hidden = false;
      try {
        const res = await fetch(nextUrl, { headers: { 'Accept': 'text/html' } });
        if (!res.ok) throw new Error('fetch failed: ' + res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector('[data-products-grid]');
        const nextSentinel = doc.querySelector('[data-infinite-sentinel]');
        if (nextGrid) {
          // Mover todos los cards del nextGrid al grid actual
          const frag = document.createDocumentFragment();
          Array.from(nextGrid.children).forEach((child) => frag.appendChild(child));
          grid.appendChild(frag);
        }
        if (nextSentinel) {
          // Hay más páginas: actualizamos el next-url y seguimos observando
          nextUrl = nextSentinel.getAttribute('data-next-url');
        } else {
          // No hay más: dejamos de observar y eliminamos sentinel
          nextUrl = null;
          observer.unobserve(sentinel);
          sentinel.remove();
          if (loader) loader.remove();
        }
      } catch (err) {
        console.error('[lcs] infinite scroll error', err);
        // Si falla, deshabilitamos para no spamear errors
        nextUrl = null;
        observer.unobserve(sentinel);
      } finally {
        loading = false;
        if (loader && nextUrl) loader.hidden = true;
      }
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) loadMore(); });
    }, { rootMargin: '600px 0px' }); // pre-fetch antes de llegar al final

    observer.observe(sentinel);
  })();

  // Expose para integraciones futuras
  window.LCSShell = {
    setCursor,
    openCart,
    closeCart,
    refreshCartUI,
    refreshCartCount,
    openMobileMenu,
    closeMobileMenu,
  };
})();
